import { Component, enableProdMode } from '@angular/core';
import { LoaderService } from '@loader';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { DataLayerService } from '../services/data-layer/data-layer.service';
import { ProfileService } from '@profile';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  loader: Observable<boolean> = this.$loader.changes;
  profileData: any;
  constructor(
    private $loader: LoaderService,
    private _router: Router,
    private _dataLayerService: DataLayerService,
    private profile: ProfileService
  ) { 
    this.profile.changes.subscribe((data) => {
      this.profileData = data;
    });
    this._router.events.subscribe(event=> {
      if (event instanceof NavigationEnd)
      {
          this._dataLayerService.logPageView(event.url)
      }
  });
  }

  ngOnInit() {
   if (environment.production) {
    enableProdMode();
    if (window) {
       window.console.log = function() {};
      }
    }
  }

}
